import React from "react";

export const defaultFleetFuelRow = {
  region: "",
  unit: "",
  averageFleetFuelEconomy: "",
};

const FleetFuelEconomyTable = ({ fleetTable, setFleetTable }) => {
  const handleInputChange = (rowIndex, field, value) => {
    const updated = [...fleetTable];
    updated[rowIndex][field] = value;
    setFleetTable(updated);
  };

  const addRow = () => {
    setFleetTable([...fleetTable, { ...defaultFleetFuelRow }]);
  };

  const removeRow = () => {
    if (fleetTable.length > 1) {
      setFleetTable(fleetTable.slice(0, -1));
    }
  };

  return (
    <div>
      {/* Table Container */}
      <div
        style={{
          marginTop: "20px",
          border: "1px solid #000",
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#d0c5ca", color: "#000" }}>
              <th style={tableHeaderStyle}>Region</th>
              <th style={tableHeaderStyle}>Unit</th>
              <th style={tableHeaderStyle}>Average Fleet Fuel Economy</th>
            </tr>
          </thead>
          <tbody>
            {fleetTable.map((row, index) => (
              <tr key={index}>
                {/* Region */}
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.region}
                    onChange={(e) =>
                      handleInputChange(index, "region", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>

                {/* Unit */}
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    value={row.unit}
                    onChange={(e) =>
                      handleInputChange(index, "unit", e.target.value)
                    }
                    style={inputFieldStyle}
                  />
                </td>

                {/* Average Fleet Fuel Economy (allow decimals only) */}
                <td style={tableCellStyle}>
                  <input
                    type="text"
                    inputMode="decimal"
                    value={row.averageFleetFuelEconomy}
                    onChange={(e) => {
                      const v = e.target.value;
                      if (/^\d*\.?\d*$/.test(v)) {
                        handleInputChange(index, "averageFleetFuelEconomy", v);
                      }
                    }}
                    style={inputFieldStyle}
                    placeholder=""
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

// Reuse the same styles as your reference
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputFieldStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default FleetFuelEconomyTable;
